import FiltersContainer from "../Filters";
import { useParams } from "react-router";
import { PaddingBottom } from "ComponentsUI/Spacings";
import ListOfProvidersWithInjectedTariffs from "ComponentsUI/ListOfProvidersWithInjectedTariffs";
import React from "react";
import { useQuery } from "@apollo/client";
import { PROVIDERS_LIST_QUERY } from "Services/queries";
import queryString from "query-string";
import { isMoscowSiteCode } from "Utils/siteConfig";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import orderBy from "lodash/orderBy";
import { inject, observer } from "mobx-react";
import Stub from "../../routes/providers/routes/catalog/Components/Stub";
import useDefaultParams from "Services/useDefaultParams";
import routes from "Configs/routes";
import { Redirect404, RedirectPagination } from "ComponentsUI/Redirects";
import { withRouter } from "react-router-dom";
import PaginationContainer from "Containers/PaginationContainer";
import Routes from "Configs/routes";

let LIMIT = 35;

const ProvidersFilterContainer = (props) => {
	let {
		ApplicationModel: { windowSizeModel, ratesModel, text },
		location: { search },
	} = props;

	const routerParams = useParams();
	const { regionUrl } = useDefaultParams(routerParams);
	const getData = (props) => {
		let page = 1;
		let random = true;
		if (props.match.params.page) {
			page = props.match.params.page;
		}
		let sort = "-vip_provider,vip_b2c_priority,-rating.expert.final,name";
		let filters = [];
		let aggregateFilter = [];
		let params = queryString.parse(props.location.search);
		if (params.sort) {
			sort = params.sort;
			random = false;
		}
		if (params.providers) {
			filters.push(`id=${params.providers}`);
		}

		if (params.service) {
			filters.push(`order_types.id=${params.service}`);
			if (!params.providers) {
				aggregateFilter.push(`order_types.id=${params.service}`);
			}
		}

		if (params.dody) {
			filters.push(`dody.global_id=${params.dody}`);
			if (!params.providers) {
				aggregateFilter.push(`dody.global_id=${params.dody}`);
			}
		}

		if (regionUrl) {
			filters.push(`region.url=${regionUrl}`);
			aggregateFilter.push(`region.url=${regionUrl}`);
		}
		if (isMoscowSiteCode(props.ApplicationModel.siteCode)) {
			LIMIT = 20;
		}

		let skip = regionUrl ? false : true;
		const variables = {
			filter: filters.join("&"),
			aggregateFilter: aggregateFilter.join("&"),
			limit: +LIMIT,
			skip: skip,
			offset: page > 0 ? +LIMIT * (page - 1) : 0,
			sort: sort,
			random,
		};
		return variables;
	};

	const options = getData(props);
	const useProvider = useQuery(PROVIDERS_LIST_QUERY, {
		skip: regionUrl ? false : true,
		variables: options,
	});
	if (useProvider.loading) return <Stub />;
	const {
		loading,
		data: {
			providers: { data, pagination },
			providersAggregate: { aggregation },
		},
	} = useProvider;
	if (loading && !data.providers) return <Stub />;

	let page = 1;

	if (props.match.params.page > -1) {
		page = parseInt(props.match.params.page);
	}

	if (props.match.params.page === "1") {
		return <RedirectPagination />;
	}
	if (!page || pagination.items_total < LIMIT * (page - 1)) {
		return <Redirect404 message404={"Выбрана пагинация больше доступной у списка провайдеров"} />;
	}
	function onProviderSelect(provider) {
		let providerModel = props.ApplicationModel.providerModel;
		providerModel.changeTab("provider_tab_card");
		props.history.push({
			pathname: generateUrl(routes.ProviderDetails.route, {
				providerName: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	}

	function onProviderRates(provider) {
		let providerModel = props.ApplicationModel.providerModel;
		providerModel.changeTab("provider_tab_tariffs");
		props.history.push({
			pathname: generateUrl(routes.ProviderRates.route, {
				providerName: provider.url_name,
				regionUrl: provider.region.url,
			}),
		});
	}

	function onProviderConnect(provider) {
		let {
			ApplicationModel: { tariffsModel },
		} = props;
		tariffsModel.setProvider(provider);
	}

	function onProviderReviews(provider) {}

	let providers = JSON.parse(JSON.stringify(data));
	providers?.map((provider) => {
		provider.linkProviderSelect = generateUrl(configRouters.ProviderDetails.route, {
			providerName: provider.url_name,
			regionUrl: provider.region.url,
		});

		provider.linkProviderReviews = generateUrl(configRouters.ProvidersReviewListOld.route, {
			regionUrl: provider.region.url,
			providerName: provider.url_name,
		});
		provider.linkProviderConnect = generateUrl(configRouters.OrderHome.route, {
			regionUrl: provider.region.url,
		});
	});

	const params = queryString.parse(search);

	if (!params.sort) {
		const providersVipTariffs = providers.filter((x) => x.vip_provider && x.info.cnt_tariffs);
		const providersVipNoTariffs = providers.filter((x) => x.vip_provider && !x.info.cnt_tariffs);
		const providersNoVipTariffs = providers.filter((x) => !x.vip_provider && x.info.cnt_tariffs);
		const providersNoVipNoTariffs = providers.filter((x) => !x.vip_provider && !x.info.cnt_tariffs);

		providers = providersVipTariffs.concat(
			providersVipNoTariffs,
			providersNoVipTariffs,
			providersNoVipNoTariffs
		);
	}

	let sortedAggregation = {};
	for (let it in aggregation) {
		sortedAggregation[it] = orderBy(aggregation[it], "name", "asc");
	}
	return (
		<>
			<FiltersContainer aggregation={sortedAggregation} />

			<PaddingBottom>
				<ListOfProvidersWithInjectedTariffs
					hideProviderLogo={true}
					text={text}
					windowSize={windowSizeModel.windowSizes}
					isRates={props.isRates}
					items={providers}
					flat={ratesModel.orientation}
					yandexEvent={"providers.impressions_vip"}
					pageName="catalog_prov"
					onProviderConnect={onProviderConnect}
					onProviderRates={onProviderRates}
					onProviderSelect={onProviderSelect}
					onProviderReviews={onProviderReviews}
				/>
			</PaddingBottom>

			<PaginationContainer
				generationUrl={Routes.Rates.route}
				limit={LIMIT}
				key={3}
				pagination={pagination}
			/>
		</>
	);
};

export default withRouter(inject("ApplicationModel")(observer(ProvidersFilterContainer)));
